import { useEffect } from 'react'

import { usePaymentOptions } from 'mmfintech-checkout-commons'
import { isSingleItemArray, isValidArray, tr } from 'mmfintech-commons'

import { ThreeDots } from 'react-loader-spinner'
import { MethodPane } from './MethodPane'
import { MethodButton } from './MethodButton'
import { SelectMethodContainer, SelectMethodEmpty, SelectMethodStyled, SelectMethodTitle } from './SelectMethod.styled'

type SelectMethodProps = {
  className?: string
  method: string
  setMethod: (method: string) => void
  errorVisible: boolean
}

export const SelectMethod = (props: SelectMethodProps) => {
  const { className, method, setMethod, errorVisible } = props

  const { paymentOptions, paymentOptionsFetching } = usePaymentOptions()

  useEffect(() => {
    if (isSingleItemArray(paymentOptions)) {
      setMethod(paymentOptions[0].paymentMethod)
    }
    // eslint-disable-next-line
  }, [paymentOptions])

  if (paymentOptionsFetching) {
    return (
      <SelectMethodStyled>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ThreeDots height='1rem' color='silver' />
        </div>
      </SelectMethodStyled>
    )
  }

  if (isValidArray(paymentOptions)) {
    if (paymentOptions.length > 1) {
      return (
        <SelectMethodStyled>
          <SelectMethodTitle>Payment With</SelectMethodTitle>
          <SelectMethodContainer className={className}>
            {paymentOptions.map(option => (
              <MethodButton
                key={option.paymentMethod}
                name={option.paymentMethod}
                selected={option.paymentMethod === method}
                setSelected={setMethod}
              />
            ))}
          </SelectMethodContainer>
        </SelectMethodStyled>
      )
    }

    return (
      <SelectMethodStyled>
        <SelectMethodTitle>Paying With</SelectMethodTitle>
        <MethodPane method={method} />
      </SelectMethodStyled>
    )
  }

  return errorVisible ? (
    <SelectMethodStyled>
      <SelectMethodEmpty>{tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}</SelectMethodEmpty>
    </SelectMethodStyled>
  ) : null
}
